var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSvgDefs = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      display: "none"
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "clock",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-clock"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "12 6 12 12 16 14"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "trash",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-trash"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "3 6 5 6 21 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "check",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-check"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "20 6 9 17 4 12"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "close-x",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "afeather afeather-x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 6L6 18M6 6l12 12"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "hamburger",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "afeather afeather-menu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 12h18M3 6h18M3 18h18"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "chevron-right",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "afeather afeather-chevron-right"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18l6-6-6-6"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "chevron-left",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-chevron-left"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "15 18 9 12 15 6"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "chevron-down",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-chevron-down"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "6 9 12 15 18 9"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "mail",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "afeather afeather-mail"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 6l-10 7L2 6"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "map-pin",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-map-pin"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 3
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "map-pin",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "afeather afeather-map-pin"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 3
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "check",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-check"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "20 6 9 17 4 12"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "plus",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "afeather afeather-plus"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 5v14M5 12h14"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "minus",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "afeather afeather-minus"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 12h14"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "open-external",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "afeather afeather-external-link",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14L21 3"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "more-horizontal",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "afeather afeather-more-horizontal",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 12,
    r: 1
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "corner-down-left",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "afeather afeather-corner-down-left",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 10l-5 5 5 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 4v7a4 4 0 0 1-4 4H4"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "return",
    viewBox: "0 0 19.964 15.332"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon Return",
    transform: "translate(0 0.627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-13226.545,7113.1h14.488c.851,0,4.476-.444,4.476-4.911a4.724,4.724,0,0,0-5.023-5.064h-6.527",
    transform: "translate(13226.545 -7099.394)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13216.083,7099.394l-3.178,3.946,3.178,3.261",
    transform: "translate(13226.545 -7099.394)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "approved",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.361,6,7.55,13.811,4,10.26",
    transform: "translate(2.911 2.189)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "three-dots",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 12,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 12,
    r: 1
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "sliders",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3M1 14h6M9 8h6M17 16h6"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "svg-empty",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }), /*#__PURE__*/React.createElement("symbol", {
    id: "svg-package-img",
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "#EDE9E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.746 17L49.4921 22.2331L32.746 27.4663L16 22.2331L32.746 17Z",
    fill: "#C5B9AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M32.746 17L49.4921 22.2331L32.746 27.4663L16 22.2331L32.746 17Z",
    fill: "#EDE9E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4921 22.2332L32.746 27.2046V49.9688L49.4921 44.7356V22.2332Z",
    fill: "#C5B9AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4921 22.2332L32.746 27.2046V49.9688L49.4921 44.7356V22.2332Z",
    fill: "#C5B9AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 22.2332L32.746 27.2046V49.9688L16 44.7356V22.2332Z",
    fill: "#C5B9AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 22.2332L32.746 27.2046V49.9688L16 44.7356V22.2332Z",
    fill: "#C5B9AC"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 22.2332L32.746 27.2046V49.9688L16 44.7356V22.2332Z",
    fill: "#7B6469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 22.2332L32.746 27.2046V49.9688L16 44.7356V22.2332Z",
    fill: "#7B6469"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2978 40.2334L22.9044 36.4799H20.8452C20.7282 36.4799 20.6457 36.4375 20.5978 36.3529C20.5499 36.2682 20.5579 36.1788 20.6217 36.0847L24.1494 30.6379H24.756L24.1494 34.3773H26.1766C26.2937 34.3773 26.3788 34.4196 26.432 34.5043C26.4853 34.589 26.4853 34.6783 26.432 34.7724L22.9044 40.2334H22.2978Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.474 24.1138V27.7279L39.0258 29.2978V25.5038L22.8031 20.1399L27.2513 18.7171L43.474 24.1138Z",
    fill: "#C5B9AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M43.474 24.1138V27.7279L39.0258 29.2979V25.5039L22.8031 20.1399L43.474 24.1138Z",
    fill: "#EDE9E5"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "print",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "6 9 6 2 18 2 18 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 14,
    width: 12,
    height: 8
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "svg-tune",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.14286 5.18857V4.16H12.0457V0H13.0971V4.16H16V5.18857H9.14286ZM12.0457 16V7.15429H13.0971V16H12.0457ZM2.90286 16V12H0V10.9714H6.85714V12H3.95429V16H2.90286ZM2.90286 9.02857V0H3.95429V9.02857H2.90286Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "trending-up",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "23 6 13.5 15.5 8.5 10.5 1 18"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "17 6 23 6 23 12"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "filter",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "download",
    viewBox: "0 0 20 18",
    fill: "none",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10.4681H2V15.4681H18V10.4681H20V15.4681C20 16.5781 19.11 17.4681 18 17.4681H2C0.9 17.4681 0 16.5781 0 15.4681V10.4681ZM10 13.4681L15.55 8.00811L14.13 6.59811L11 9.71811V0.468109H9V9.71811L5.88 6.59811L4.46 8.01811L10 13.4681Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "dealer-head",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C10.4241 0 8.86371 0.310389 7.4078 0.913446C5.95189 1.5165 4.62902 2.40042 3.51472 3.51472C1.26428 5.76516 0 8.8174 0 12C0 15.1826 1.26428 18.2348 3.51472 20.4853C4.62902 21.5996 5.95189 22.4835 7.4078 23.0866C8.86371 23.6896 10.4241 24 12 24C15.1826 24 18.2348 22.7357 20.4853 20.4853C22.7357 18.2348 24 15.1826 24 12C24 10.4241 23.6896 8.86371 23.0866 7.4078C22.4835 5.95189 21.5996 4.62902 20.4853 3.51472C19.371 2.40042 18.0481 1.5165 16.5922 0.913446C15.1363 0.310389 13.5759 0 12 0ZM12 7.668C13.884 8.88 16.104 9.6 18.504 9.6C19.44 9.6 20.34 9.492 21.204 9.288C21.456 10.14 21.6 11.052 21.6 12C21.6 17.292 17.292 21.6 12 21.6C8.4 21.6 5.268 19.608 3.6 16.668L5.7 14.4V13.2C5.7 12.8022 5.85804 12.4206 6.13934 12.1393C6.42064 11.858 6.80218 11.7 7.2 11.7C7.59783 11.7 7.97936 11.858 8.26066 12.1393C8.54197 12.4206 8.7 12.8022 8.7 13.2V14.4H12M16.8 11.7C16.4022 11.7 16.0206 11.858 15.7393 12.1393C15.458 12.4206 15.3 12.8022 15.3 13.2C15.3 13.5978 15.458 13.9794 15.7393 14.2607C16.0206 14.542 16.4022 14.7 16.8 14.7C17.1978 14.7 17.5794 14.542 17.8607 14.2607C18.142 13.9794 18.3 13.5978 18.3 13.2C18.3 12.8022 18.142 12.4206 17.8607 12.1393C17.5794 11.858 17.1978 11.7 16.8 11.7Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "roof-icon",
    viewBox: "2 -8 40 40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4002 4.5462L23.0516 7.32907L6.94471 13.3203L10.5987 10.0503L26.4002 4.5462Z",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9718 2.95343L38.1678 12.4193L18.8478 19.6057L11.6493 9.68408L30.9718 2.95343Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "angle-icon",
    viewBox: "-3 -3 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.11 14.57H0.199951L10.29 0L11.93 1.14L7.38995 7.7C8.99995 8.53 10.11 10.19 10.11 12.11C10.11 12.27 10.11 12.42 10.08 12.57H16.11V14.57ZM4.01995 12.57H8.06995C8.10995 12.42 8.10995 12.27 8.10995 12.11C8.10995 10.85 7.34995 9.79 6.24995 9.35L4.01995 12.57Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "panels-icon",
    viewBox: "-3 -3 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,18c0.5,0,1-0.2,1.4-0.6C17.8,17,18,16.5,18,16h-2 M14,18v-2h-2v2 M10,18v-2H8v2 M6,18v-2H4v2 M2,18v-2H0 c0,0.5,0.2,1,0.6,1.4C1,17.8,1.5,18,2,18z M18,14v-2h-2v2 M14,14v-4h-4v4 M8,14v-4H4v4 M2,14v-2H0l0,2 M18,10V8h-2v2 M2,10V8H0l0,2  M14,8V4h-4v4 M8,8V4H4v4 M18,6V4h-2v2 M2,6V4H0l0,2 M18,2c0-0.5-0.2-1-0.6-1.4C17,0.2,16.5,0,16,0v2 M14,2V0l-2,0v2 M10,2V0L8,0v2  M6,2V0L4,0v2 M2,2V0C1.5,0,1,0.2,0.6,0.6C0.2,1,0,1.5,0,2H2z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "person-icon",
    viewBox: "-3 -3 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M16.5 19.5V17.5C16.5 16.4391 16.0786 15.4217 15.3284 14.6716C14.5783 13.9214 13.5609 13.5 12.5 13.5L4.5 13.5C3.43913 13.5 2.42172 13.9214 1.67157 14.6716C0.921427 15.4217 0.5 16.4391 0.5 17.5L0.5 19.5M20.5 19.5V17.5C20.4993 16.6137 20.2044 15.7528 19.6614 15.0523C19.1184 14.3519 18.3581 13.8516 17.5 13.63M13.5 1.63C14.3604 1.8503 15.123 2.3507 15.6676 3.05231C16.2122 3.75392 16.5078 4.61683 16.5078 5.505C16.5078 6.39317 16.2122 7.25608 15.6676 7.95769C15.123 8.6593 14.3604 9.1597 13.5 9.38M12.5 5.5C12.5 7.70914 10.7091 9.5 8.5 9.5C6.29086 9.5 4.5 7.70914 4.5 5.5C4.5 3.29086 6.29086 1.5 8.5 1.5C10.7091 1.5 12.5 3.29086 12.5 5.5Z",
    stroke: "#0072CE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSvgDefs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/svgDefs.dfb793fc19dacf4a72c3a333c8772508.svg";